import { useTranslation } from "react-i18next";
import { EnrolledBeneficiaryType } from "@/types/beneficiaries";
import Tooltip from "@/components/Common/Tooltip";
import { formatMoney } from "@/utils/generalUtilities";

interface ContributionsGridProps {
  beneficiary: EnrolledBeneficiaryType;
  calculations: {
    totalEmployerContrib: number;
    formatTruncatedMoney: (value: number) => number;
  };
}

const ContributionsGrid = ({
  beneficiary,
  calculations,
}: ContributionsGridProps) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
      <div className="flex flex-row lg:flex-col items-center lg:items-start justify-between p-[16px] lg:p-[32px] border rounded-xl bg-gradient-to-b border-b-4 border-[#BDE9FC] from-[#2FB7F2] to-[#E8F8FF]">
        <p>
          {t("home.beneficiary_card.personal")}{" "}
          <span className="text-[18px] ml-1">
            <Tooltip
              text={
                "The amount you own permanently. You can withdraw this amount any time as long as it meets the criteria for withdraw."
              }
            />
          </span>
        </p>
        <p className="text-[30px] font-semibold">
          ${" "}
          {formatMoney(
            calculations.formatTruncatedMoney(
              beneficiary.actualEmployeeContribution || 0,
            ),
          )}
        </p>
      </div>
      <div className="flex flex-row lg:flex-col items-center lg:items-start justify-between p-[16px] lg:p-[32px] border rounded-xl bg-gradient-to-b border-b-4 border-[#FDE5CE] from-[#F69334] to-[#FFF8F1]">
        <p>
          {t("home.beneficiary_card.employer")}
          <span className="text-[18px] ml-1">
            <Tooltip
              text={
                "Employer contributions you haven't fully earned yet. If you leave before fully vesting, you may forfeit this amount."
              }
            />
          </span>
        </p>
        <p className="text-[30px] font-semibold">
          ${" "}
          {formatMoney(
            calculations.formatTruncatedMoney(
              calculations.totalEmployerContrib,
            ),
          )}
        </p>
      </div>
      <div className="flex flex-row lg:flex-col items-center lg:items-start justify-between p-[16px] lg:p-[32px] border outline-1 rounded-xl bg-gradient-to-b border-b-4 border-[#FEDFF5] from-[#F634C0] to-[rgba(246,52,192,0.00)]">
        <p>{t("home.beneficiary_card.gifts")}</p>
        <div className="bg-white text-[14px] py-2 px-4 rounded-lg">
          {t("home.beneficiary_card.coming_soon")}
        </div>
      </div>
    </div>
  );
};

export default ContributionsGrid;
